import { ELetterBatchStatus, ELetterChunkStatus, EPreLodEmailType } from '../enums/payment-reminder.enum';

export interface IPaymentReminderSkipReasons {
  firstReminderFirstSkipReason?: string;
  firstReminderSecondSkipReason?: string;
  firstReminderFinalSkipReason?: string;
  finalReminderFirstSkipReason?: string;
  finalReminderSecondSkipReason?: string;
  finalReminderFinalSkipReason?: string;
  lodFirstSkipReason?: string;
  lodSecondSkipReason?: string;
  lodFinalSkipReason?: string;
}

export interface IPaymentReminderSkip {
  id: number;
  paymentReminderId: number;
  firstReminderFirstSkipDueDate: string | null;
  firstReminderSecondSkipDueDate: string | null;
  firstReminderFinalSkipDueDate: string | null;
  finalReminderFirstSkipDueDate: string | null;
  finalReminderSecondSkipDueDate: string | null;
  finalReminderFinalSkipDueDate: string | null;
  lodFirstSkipDueDate: string | null;
  lodSecondSkipDueDate: string | null;
  lodFinalSkipDueDate: string | null;
  skipReasons: IPaymentReminderSkipReasons;
}

export interface ISkipRecord {
  newDueDate: string;
  reason?: string;
  createdBy?: string;
}

export interface IPaymentReminderPreLodEmailInfo {
  infoId: number;
  paymentDeadline: number;
  sentAt: string;
}

export type IPaymentReminderPreLodRecords = Partial<Record<EPreLodEmailType, IPaymentReminderPreLodEmailInfo>>;

export interface IPreLodEmailDialogData {
  id: number;
  preLod: IPaymentReminderPreLodRecords | null | undefined;
}

export interface IJobLetterBatchResponse {
  jobId: string;
}

export interface IJobLetterBatchChunk {
  seq: number;
  status: ELetterChunkStatus;
  letterCount: number;
  skippedCount: number;
  filename: string;
  errorMessage: string | null;
  url: string | null;
}

export interface IJobLetterBatchStatusResponse {
  jobId: string;
  status: ELetterBatchStatus;
  letterType: string;
  totalLetters: number;
  totalChunks: number;
  completedChunks: number;
  failedChunks: number;
  skippedLetters: number;
  errorMessage: string | null;
  expiresAt: string | null;
  chunks: IJobLetterBatchChunk[];
}
